import axios from 'axios';

const instance = axios.create({})

export default {
    getAcademySettings: () => {
        return new Promise((resolve, reject) => {
            instance.get("/ap.config.json?v=20241017234814").then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err.response);
            })
        })
    },
    getJsonFile: (path) => {
        return new Promise((resolve, reject) => {            
            instance.get(`/${path}.json?v=20241017234814`).then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err.response);
            })
        });
    }
}
  